import { render, staticRenderFns } from "./answerDetail.vue?vue&type=template&id=1337eb97&scoped=true&"
import script from "./answerDetail.vue?vue&type=script&lang=js&"
export * from "./answerDetail.vue?vue&type=script&lang=js&"
import style0 from "./answerDetail.vue?vue&type=style&index=0&id=1337eb97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1337eb97",
  null
  
)

component.options.__file = "answerDetail.vue"
export default component.exports